/**
 * Supported locale codes for the Hostesa platform.
 * Add new locales here AND add the corresponding locale JSON files under
 * src/locales/<code>/common.json — the key-parity test will fail otherwise.
 */
export const SUPPORTED_LOCALES = ['en', 'bg', 'de', 'fr'] as const;

/** Union of all supported locale codes. */
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/** The locale used when no explicit locale is resolved. */
export const DEFAULT_LOCALE: SupportedLocale = 'en';

/** i18next namespace names used in this package. */
export const NAMESPACES = ['common'] as const;
export type Namespace = (typeof NAMESPACES)[number];

/** Default namespace for useTranslation / t() calls. */
export const DEFAULT_NAMESPACE: Namespace = 'common';

/**
 * Type-guard: checks whether an arbitrary string is a supported locale code.
 */
export function isSupportedLocale(value: string): value is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
